<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <!-- <div class="section-title">{{ $t('plannedschedule') }}</div> -->
        <div class="section-title">{{ $t("scheduleList") }}</div>

        <!-- <div class="section-subTitle my-2">{{ $t('screen_dash_msg') }}</div> -->
      </div>

      <div class="d-flex justify-content-between align-items-center my-3">
        <b-dropdown name="listview" id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- {{ $t("viewing") }}&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="col-12">
      <div class="row white-wrapper" style="margin-bottom: 20px">
        <div class="col-lg-6 col-xl-3 mb-3">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <!-- <b-dropdown
              :disabled="isRoleID"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
              >{{ Cinema.cine_name }}</b-dropdown-item>
            </b-dropdown>-->
            <multiselect
              :disabled="isRoleID"
              :options="CinemasList"
              v-model="selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              :placeholder="$t('selectCinema')"
              @input="onSelectCinema($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedCinema && selectedCinema.length == 0"
              >{{ msgcinema }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.screen_name && selected.screen_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("screen", 1) }}</label
            >
            <!-- :disabled="ScreenList.length == 0" -->
            <!-- <b-dropdown :text="selected.screen_name" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in ScreenList"
                @click="onSelectScreen($event, Screen, ScreenIndex)"
                :key="ScreenIndex"
              >{{ Screen.screen_name }}</b-dropdown-item>
            </b-dropdown>-->
            <multiselect
              :options="ScreenList"
              v-model="selectedScreen"
              :searchable="true"
              label="screen_name"
              track-by="screen_id"
              :placeholder="$t('select_screens')"
              @input="onSelectScreen($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedScreen && selectedScreen.length == 0"
              class="error_message"
              >{{ msgscreen }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.movie_name && selected.movie_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("movie", 1) }}</label
            >
            <!-- <b-dropdown :text="selected.movie_name" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(movie, movieIndex) in MoviesList"
                @click="onSelectMovie($event, movie)"
                :key="movieIndex"
              >{{ movie.movie_title }} {{(movie.lang_name)}} {{(movie.mf_name)}}</b-dropdown-item>
            </b-dropdown>-->
            <multiselect
              :options="MoviesList"
              v-model="selectedMovie"
              :searchable="true"
              label="movie_name"
              track-by="md_id"
              :placeholder="$t('selectMovies')"
              @input="onSelectMovie($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selectedMovie && selectedMovie.length == 0"
              class="error_message"
              >{{ msgmovie }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  id="showdate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- {{showdate.length}} -->
                <label :class="typeof showdate === 'object' ? 'active' : ''"
                  >{{ $t("select") }} {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="false">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.status_name && selected.status_name.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("type", 1) }}</label
            >
            <!-- :disabled="ScreenList.length == 0" -->
            <!-- <b-dropdown :text="selected.status_name" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Status, StatusIndex) in status_list"
                :key="StatusIndex"
                @click="onSelectStatus($event, Status)"
              >{{ Status.s_status_display }}</b-dropdown-item>
            </b-dropdown>-->
            <multiselect
              :options="status_list"
              v-model="selectedType"
              :searchable="true"
              label="s_status_display"
              track-by="s_id"
              placeholder="Select Type"
              @input="onSelectStatus($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>

        <div class="col-12">
          <div class="row justify-content-center">
            <div class="col-lg-4 col-xl-2 align-self-center mb-3">
              <button
                :disabled="btenable"
                @click.prevent.stop="Onfetch(true)"
                class="btn btn-blue w-100 px-2"
              >
                {{ $t("fetch") }}
              </button>
            </div>

            <div class="col-lg-4 col-xl-2 align-self-center mb-3">
              <button
                @click.prevent.stop="OnClear()"
                class="btn btn-blue w-100 px-2"
              >
                {{ $t("clear") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <table class="white-wrapper list-view-table">
        <thead>
          <tr class="text-center">
            <th></th>
            <th>
              <img
                v-if="this.columnName != 'ss_start_date'"
                @click="
                  onSortValue('ss_start_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue('ss_start_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('ss_start_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("start") }} {{ $t("date") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'ss_end_date'"
                @click="
                  onSortValue('ss_end_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue('ss_end_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('ss_end_date', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("end") }} {{ $t("date") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'start_time_range'"
                @click="
                  onSortValue(
                    'start_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue(
                    'start_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue(
                    'start_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ $t("start") }} {{ $t("time") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'end_time_range'"
                @click="
                  onSortValue(
                    'end_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue(
                    'end_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue(
                    'end_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ $t("end") }} {{ $t("time") }}
            </th>

            <th class="text-left">
              <img
                v-if="this.columnName != 'movie_title'"
                @click="
                  onSortValue('movie_title', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue('movie_title', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('movie_title', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ $tc("movie", 1) }} {{ $t("name") }}
            </th>
            <th class="text-left">
              <img
                v-if="this.columnName != 'cine_name'"
                @click="
                  onSortValue('cine_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue('cine_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('cine_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ $tc("cinema", 1) }} {{ $t("name") }}
            </th>
            <th class="text-left">
              <img
                v-if="this.columnName != 'screen_name'"
                @click="
                  onSortValue('screen_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue('screen_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue('screen_name', (dateAscending = !dateAscending))
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("screen", 1) }} {{ $t("name") }}
            </th>

            <th class="text-right">
              <img
                v-if="this.columnName != 'interval_time_range'"
                @click="
                  onSortValue(
                    'interval_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="dateAscending"
                @click="
                  onSortValue(
                    'interval_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="
                  onSortValue(
                    'interval_time_range',
                    (dateAscending = !dateAscending)
                  )
                "
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("intervaltime") }}
            </th>

            <!-- <th class="d-flex align-items-center">Status</th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center"
            v-for="(item, key) in ScheduleList"
            :key="key"
          >
            <!-- <td>
              <b-dropdown
                right
                variant="edit"
                id="dropdown-dropup"
                dropup
                class="align-self-end mt-2"
              >
                <b-dropdown-item
                  @click="onClickEditSchedule(item)"
                  v-if="$can('update', 'Cinema Schedule List')"
                  >{{ $t("edit") }}</b-dropdown-item
                >
              </b-dropdown>
            </td> -->
            <td>
              <i
                v-if="$can('update', 'Cinema Schedule List')"
                class="edit-pen icon blue-icon cursor-pointer mt-2"
                @click="onClickEditSchedule(item)"
                v-b-tooltip="'Edit'"
                tabindex="0"
              ></i>
            </td>

            <td>{{ item.ss_start_date | dateparse }}</td>
            <td>{{ item.ss_end_date | dateparse }}</td>
            <td>{{ item.start_time_range }}</td>
            <td>{{ item.end_time_range }}</td>

            <td class="text-left">{{ item.movie_title }}</td>
            <td class="text-left">{{ item.cine_name }}</td>

            <td class="text-left">{{ item.screen_name }}</td>
            <td class="text-right">{{ item.interval_time_range }}</td>

            <!-- <td class="row d-flex align-items-center">
              <div class="col-8">
                {{
                  item.ss_show_status == 13
                    ? "Show Closed"
                    : item.ss_id == null
                    ? item.show_exist == "Y"
                      ? "Show Blocked"
                      : "No Action"
                    : item.ss_category_id == 2 && item.ss_show_status == 16
                    ? "Confirmed"
                    : item.ss_show_status == 14
                    ? "Show Cancelled"
                    : "UnConfirmed"
                }}
              </div>
              <div class="col-4">
                <b-dropdown right variant="edit" class="ml-3">
                  <!-- <b-dropdown-item
                    @click.prevent.stop="OpenModal(item.gogo_ss_id, 'Comment')"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("add") }}/{{ $t("edit") }} Comment
                  </b-dropdown-item> -->

            <!-- <b-dropdown-item
                    @click.prevent.stop="OpenModal(item, 'Schedule')"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }} {{ $t("Schedule") }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    @click.prevent.stop="OpenModal(item, 'Price')"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("update") }} {{ $tc("price", 1) }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    :to="{
                      name: 'Schedule Transactions',
                      params: { ss_id: item.ss_id },
                    }"
                    v-if="item.ss_id"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("view") }} {{ $t("transactions") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="item.ss_id"
                    :to="{
                      name: 'Schedule Seat Layout',
                      params: {
                        ss_id: item.ss_id,
                        md_id: item.md_id,
                        screen_id: item.screen_id,
                      },
                    }"
                  >
                    <span class="edit-pen mr-1"></span>
                    Schedule Seat Layout
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
          </tr>
        </tbody>
        <tbody v-if="ScheduleList.length === 0">
          <tr></tr>
          <tr>
            <td class="tetx-center" colspan="10">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal id="add_comment" title="Add Comments" hide-footer>
      <div>
        <div class="mt-4 mb-4">
          <multiselect
            v-model="selected_comment"
            placeholder="Select Comment"
            track-by="comment_name"
            label="comment_name"
            :options="comments_list"
          ></multiselect>
        </div>
        <button
          class="btn btn-blue w-100 px-2"
          @click.prevent.stop="onFinalSubmit()"
        >
          Add/Update Comment
        </button>
      </div>
    </b-modal>

    <b-modal
      id="updateMovie"
      ref="updateMovie"
      title="Update Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div class>
                  <date-picker
                    v-model="movieSelected.selected_time"
                    @change="onChangeShowStartTime($event)"
                    lang="en"
                    type="time"
                    format="HH:mm"
                    :minute-step="1"
                    class="time_picker"
                    placeholder="Show Time"
                    name="showtime"
                    id="showtime"
                    v-validate="'required'"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.ss_end_show_time | timeFormat
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong
                  >{{ movieSelected.cine_interval_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong
                  >{{ movieSelected.cine_cleaning_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="saveMovie"
      ref="ratecardmodal"
      title="Update Price"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Showtime:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Runtime:</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time:</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div
            v-if="selectedScreenSeatTypes && selectedScreenSeatTypes.length > 0"
            v-for="(SeatTypes, SeatTypesIndex) in selectedScreenSeatTypes"
            :key="SeatTypesIndex"
            class="col-12 border-bottom py-2"
          >
            <div class="row">
              <div class="col-4">
                {{
                  SeatTypes.screen_seat_type_id == 0
                    ? "Private Screening"
                    : SeatTypes.sst_seat_type
                }}
              </div>
              <div
                v-if="
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ]
                "
                class="col-8 d-flex align-items-center"
              >
                <!-- {{
                 selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[SeatTypesIndex]
                }} -->
                <b-dropdown
                  class="w-100"
                  variant="dropdown-curve"
                  :text="
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[SeatTypesIndex].rc_name
                  "
                >
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search rate card"
                    class="form-control form-control-sm"
                    v-model="
                      selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[SeatTypesIndex].searchRateCard
                    "
                    v-on:keyup="
                      onSearchRateCard(
                        selectedScreenIndex,
                        selectedMovieIndex,
                        SeatTypesIndex
                      )
                    "
                    v-on:keydown="
                      onSearchRateCard(
                        selectedScreenIndex,
                        selectedMovieIndex,
                        SeatTypesIndex
                      )
                    "
                  />
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in RatecardsList"
                    :key="RatecardIndex"
                    v-on:click="
                      onChangeRateCard(Ratecard, SeatTypes, SeatTypesIndex)
                    "
                    >{{ Ratecard.rate_card_name }}</b-dropdown-item
                  >
                </b-dropdown>

                <!-- <select
                  v-on:change="onChangeRateCard($event,SeatTypes,SeatTypesIndex)"
                  v-model="selectedMoviesInScreens[selectedScreenIndex].movies[selectedMovieIndex].scheduleShowPrice[SeatTypesIndex].rate_card_id"
                  class="select-ratecard selectpicker"
                >
                  <option disabled>Select Rate Card</option>
                  <option
                    v-for="(Ratecard, RatecardIndex) in  RatecardsList"
                    :key="RatecardIndex"
                    :value="Ratecard.rc_id"
                  >{{ Ratecard.rate_card_name }}</option>
                </select>-->
              </div>
            </div>
          </div>
          <div class="col-12 pt-3 text-center">
            <button v-on:click="onClickupdateRateCard()" class="btn-blue">
              Update
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import MyCinemaService from "@/services/MyCinemaService";
import CinemasService from "@/services/CinemasService";
import ScheduleCommentService from "@/services/ScheduleCommentsService.js";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import moment, { min } from "moment";
import DatePicker from "vue2-datepicker";
import momentT from "moment-timezone";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      selectedCinema: null,
      selectedScreen: null,
      selectedMovie: null,
      selectedType: null,
      comments_list: [],
      selected_comment: null,

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null,
      enable: false,
      btenable: false,
      openindi: false,
      isRoleID: true,
      submitted: false,
      selected: {
        cinema: "",
        screen_name: "",
        movie_name: "",
        show_time: "",
        status_name: "",
      },
      selectedRateCardObject: {},
      selected_schedule: [],
      showdate: "",
      cineid: "",
      screenid: "",
      movieid: "",
      status_id: null,
      CinemasList: [],
      MoviesList: [],
      ScreenList: [],
      selectedMoviesInScreens: [],
      ScheduleList: [],
      update_gogo_ss_id: null,
      status_list: [],
      movieSelected: [],
      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },
      CinemasSettings: {},
      RatecardsList: [],
      RatecardsListCopy: [],
      ScreenforCinema: [],
      selectedScreenSeatTypes: [],
      dateAscending: true,
      dateUpDown: true,
      columnName: "",
      Flag: "DESC",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);
      this.Onfetch(true);
    } else {
      this.getAllActiveCinemas(obj);
    }
    this.GetAllActiveScreens();
    this.getAllActiveMovies();
    this.getStatuses();
    this.getviewingnumber();
  },
  mounted() {
    //  this.getCommentsList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onClickEditSchedule(schedule) {
      console.log("schedule :>> ", schedule);
      this.$router.push({
        path: `/my-cinema/edit-schedule`,
        query: {
          scheduleId: schedule.cinema_ss_id,
        },
      });
    },
    onSortValue: function (column, ascending) {
      // if (column == "date") {
      this.dateUpDown = false;
      this.columnName = column;
      if (ascending == false) {
        this.Flag = "DESC";
        this.Onfetch(true);
        // this.ScheduleList = this.ScheduleList.sort(function(a, b) {
        //   return new Date(a.ss_start_date) - new Date(b.ss_start_date);
        // });
      } else {
        this.Flag = "ASC";
        this.Onfetch(true);
        // this.ScheduleList = this.ScheduleList.sort(function(a, b) {
        //   return new Date(b.ss_start_date) - new Date(a.ss_start_date);
        // });
      }
      // }
    },
    convertToHrs: function (value) {
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + "." + minutes + " Hrs";
    },
    onChangeShowStartTime: function (event) {
      this.movieSelected["selected_time"] = event;
      this.$forceUpdate();
    },
    onChangeRateCard: function (rateCard, seat, SeatTypeIndex) {
      console.log(rateCard, seat);
      this.selectedRateCardObject.rate_card_id = rateCard.rc_id;
      this.selectedRateCardObject.screen_seat_type_id =
        seat.screen_seat_type_id;
      this.selectedRateCardObject.SeatTypeIndex = SeatTypeIndex;

      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rate_card_id"
      ] = this.selectedRateCardObject.rate_card_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "rc_name"
      ] = rateCard.rate_card_name;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
        "screen_seat_type_id"
      ] = this.selectedRateCardObject.screen_seat_type_id;
    },
    onClickupdateRateCard: function () {
      if (
        (this.selectedRateCardObject &&
          Object.keys(this.selectedRateCardObject).length == 0) ||
        String(this.selectedRateCardObject.SeatTypeIndex).length == 0
      ) {
        this.$toasted.show("Please Select Rate Card");
        return;
      }
      let payload = {
        gogo_ss_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
            "gogo_ss_id"
          ],
        ss_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[this.selectedRateCardObject.SeatTypeIndex][
            "ss_id"
          ],
        scheduleshowprice:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice,
      };
      console.log(payload);

      MyCinemaService.UpdateCinemaScheduleByPrice(payload)
        .then((result) => {
          const { data } = result;
          if (data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("err :", err);
          this.$toasted.show(this._CatchError);
        });
      this.searchRateCard = "";
      this.$refs.ratecardmodal.hide();
    },
    onUpdate: function () {
      let start = 0;
      let old_show_time = this.movieSelected.ss_actual_start_date_time;
      let movie_name_format = `${this.movieSelected.movie_title} ${this.movieSelected.mf_name} (${this.movieSelected.lang_name})`;

      console.log("old_show_time :>> ", old_show_time);
      let ss_actual_start_date_time = null;
      let ss_actual_end_date_time = null;
      let ss_actual_start_date = null;
      let ss_actual_end_date = null;
      let ss_end_date = null;
      let ss_end_date_time = null;

      this.movieSelected.start_time = this.onChangeTimePicker(
        this.movieSelected.selected_time
      );
      let cinema_start = this.getScreenPositionCalc(
        this.CinemasSettings.cine_operation_start_time
      );
      let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time
        ).isSameOrBefore(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          )
        )
      ) {
        console.log("camehere11111 :");
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.movieSelected.start_time
            )
          )
        ) {
          show_start_time =
            4320 + this.getScreenPositionCalc(this.movieSelected.start_time);
        } else {
          console.log("camehere222222222222 :");

          show_start_time = this.getScreenPositionCalc(
            this.movieSelected.start_time
          );
        }
      } else {
        console.log("camehere333333333333333333333 :");

        show_start_time = this.getScreenPositionCalc(
          this.movieSelected.start_time
        );
      }

      let start_delay = this.getScreenPositionCalc("00:30");
      start = show_start_time - cinema_start + start_delay;
      this.movieSelected.start = start;
      let end_time = moment(this.movieSelected.selected_time)
        .add(parseInt(this.movieSelected.lengthMinutes), "m")
        .toDate();

      this.movieSelected.end_time = moment(end_time).format("hh:mm A");

      let date = moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD");

      let showtime = format24Hours(
        date,
        moment(this.movieSelected.selected_time).format("hh:mm A")
      );
      let endShowtime = format24Hours(date, this.movieSelected.end_time);
      let ss_start_date_time = +new Date(
        moment(date).format("YYYY-MM-DD") +
          "T" +
          showtime +
          this.timeZone.tz_utc_offset
      );

      function format24Hours(date, time) {
        let newVal = date + " " + time;
        console.log(newVal);
        let finalVal = moment(newVal).format("HH:mm");
        return finalVal;
      }

      function toUnixTimeStamp(Datestring) {
        return new Date(Datestring.toString()).getTime() / 1000;
      }

      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isSameOrAfter(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
        )
      ) {
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.movieSelected.start_time
            )
          )
        ) {
          ss_actual_start_date = moment(date)
            .add(1, "days")
            .format("YYYY-MM-DD");
          ss_actual_start_date_time = +new Date(
            moment(date).add(1, "days").format("YYYY-MM-DD") +
              "T" +
              showtime +
              this.timeZone.tz_utc_offset
          );
          ss_actual_end_date = moment(date).add(1, "days").format("YYYY-MM-DD");
          ss_actual_end_date_time = +new Date(
            moment(date).add(1, "days").format("YYYY-MM-DD") +
              "T" +
              endShowtime +
              this.timeZone.tz_utc_offset
          );
          ss_end_date = moment(date).add(1, "days").format("YYYY-MM-DD");

          ss_end_date_time = +new Date(
            moment(date).add(1, "days").format("YYYY-MM-DD") +
              "T" +
              endShowtime +
              this.timeZone.tz_utc_offset
          );
        } else {
          ss_actual_start_date = moment(date).format("YYYY-MM-DD");
          ss_actual_start_date_time = +new Date(
            moment(date).format("YYYY-MM-DD") +
              "T" +
              showtime +
              this.timeZone.tz_utc_offset
          );
          ss_actual_end_date =
            this.movieSelected.start_time.split(" ")[1] == "PM" &&
            this.movieSelected.end_time.split(" ")[1] == "AM"
              ? moment(date).add(1, "days").format("YYYY-MM-DD")
              : moment(date).format("YYYY-MM-DD");

          ss_actual_end_date_time =
            this.movieSelected.start_time.split(" ")[1] == "PM" &&
            this.movieSelected.end_time.split(" ")[1] == "AM"
              ? +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                )
              : +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
          ss_end_date =
            this.movieSelected.start_time.split(" ")[1] == "PM" &&
            this.movieSelected.end_time.split(" ")[1] == "AM"
              ? moment(date).add(1, "days").format("YYYY-MM-DD")
              : moment(date).format("YYYY-MM-DD");

          ss_end_date_time =
            this.movieSelected.start_time.split(" ")[1] == "PM" &&
            this.movieSelected.end_time.split(" ")[1] == "AM"
              ? +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                )
              : +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
        }
      } else {
        ss_actual_start_date = moment(date).format("YYYY-MM-DD");
        ss_actual_start_date_time = +new Date(
          moment(date).format("YYYY-MM-DD") +
            "T" +
            showtime +
            this.timeZone.tz_utc_offset
        );
        ss_actual_end_date =
          this.movieSelected.start_time.split(" ")[1] == "PM" &&
          this.movieSelected.end_time.split(" ")[1] == "AM"
            ? moment(date).add(1, "days").format("YYYY-MM-DD")
            : moment(date).format("YYYY-MM-DD");

        ss_actual_end_date_time =
          this.movieSelected.start_time.split(" ")[1] == "PM" &&
          this.movieSelected.end_time.split(" ")[1] == "AM"
            ? +new Date(
                moment(date).add(1, "days").format("YYYY-MM-DD") +
                  "T" +
                  endShowtime +
                  this.timeZone.tz_utc_offset
              )
            : +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  endShowtime +
                  this.timeZone.tz_utc_offset
              );
        ss_end_date =
          this.movieSelected.start_time.split(" ")[1] == "PM" &&
          this.movieSelected.end_time.split(" ")[1] == "AM"
            ? moment(date).add(1, "days").format("YYYY-MM-DD")
            : moment(date).format("YYYY-MM-DD");

        ss_end_date_time =
          this.movieSelected.start_time.split(" ")[1] == "PM" &&
          this.movieSelected.end_time.split(" ")[1] == "AM"
            ? +new Date(
                moment(date).add(1, "days").format("YYYY-MM-DD") +
                  "T" +
                  endShowtime +
                  this.timeZone.tz_utc_offset
              )
            : +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  endShowtime +
                  this.timeZone.tz_utc_offset
              );
      }

      let payload = {
        show_schedule_id: this.movieSelected.gogo_ss_id,
        screen_id: this.movieSelected.screen_id,
        ss_start_show_time: showtime, // this.movieSelected.start_time,
        ss_end_show_time: endShowtime, // this.movieSelected.end_time,
        ss_start_date_time: ss_start_date_time,
        ss_end_date_time: ss_end_date_time,
        ss_actual_end_date: ss_actual_end_date,
        ss_actual_end_date_time: ss_actual_end_date_time,
        ss_actual_start_date: ss_actual_start_date,
        ss_actual_start_date_time: ss_actual_start_date_time,
        old_show_time: old_show_time,
        movie_format_name: movie_name_format,
        md_id: this.movieSelected.md_id,
        ss_id: this.movieSelected.ss_id,
      };
      MyCinemaService.UpdateCinemaScheduleByShow(payload)
        .then((result) => {
          console.log(result);
          this.$toasted.show(result.data.message);
          if (result.data.status) {
            this.Onfetch(true);
          }
        })
        .catch((err) => {
          console.log("err :", err);
        });

      this.$refs.updateMovie.hide();
    },
    getScheduleChecker: function () {
      let currentDate = "";
      let end_time = "";
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isSameOrAfter(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
        )
      ) {
        console.log("come1");
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
          )
        ) {
          console.log("come2");

          this.currentDate =
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");
          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        } else {
          console.log("come3");

          this.currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");

          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        }
      } else {
        console.log("come3");

        this.currentDate =
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
          " " +
          moment(this.movieSelected.selected_time).format("HH:mm");

        this.currentDate = moment(this.currentDate).valueOf();
        this.end_time = moment(
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm")
        )
          .add(parseInt(this.movieSelected.lengthMinutes), "m")
          .toDate();

        this.end_time = moment(this.end_time).valueOf();
      }

      this.convertToTime(
        this.movieSelected.start,
        this.movieSelected.lengthMinutes
      );

      return new Promise((resolve, reject) => {
        this.selectedMoviesInScreens = this.selectedMoviesInScreens.map((x) => {
          x.movies = [];
          return x;
        });

        let payload = {
          cinema_id: this.movieSelected.cine_id,
          start_date: moment(this.movieSelected.ss_start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          ss_show_status: this.movieSelected.ss_show_status,
        };
        scheduleService
          .GetCinemaSchedule(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status && data.Records.length > 0) {
              let newRecords = data.Records;
              let array = [];

              for (let index = 0; index < newRecords.length; index++) {
                const element = newRecords[index];
                if (element.gogo_ss_id != this.movieSelected.gogo_ss_id) {
                  let old_movie_start_date = moment(
                    element.ss_actual_start_date_time
                  )
                    .tz(this.timeZone.tz_name)

                    .format("YYYY-MM-DD HH:mm:ss");
                  let old_movie_end_date = moment(
                    element.ss_actual_end_date_time
                  )
                    .tz(this.timeZone.tz_name)

                    .format("YYYY-MM-DD HH:mm:ss");
                  let new_movie_end_date = moment(this.end_time).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  let new_movie_start_date = moment(this.currentDate).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );

                  let valid = moment(old_movie_end_date).isBetween(
                    new_movie_start_date,
                    new_movie_end_date
                  );
                  let validSame =
                    moment(old_movie_end_date).isSame(new_movie_end_date);
                  let validSame1 =
                    moment(old_movie_start_date).isSame(new_movie_start_date);
                  let valid1 = moment(new_movie_end_date).isBetween(
                    old_movie_start_date,
                    old_movie_end_date
                  );

                  if (
                    element.screen_id == this.movieSelected.screen_id &&
                    valid1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    valid
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    validSame
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.movieSelected.screen_id &&
                    validSame1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else {
                    array.push(element.ss_start_show_time);
                    console.log("1 :");

                    if (array.length === newRecords.length - 1) {
                      console.log("2 :");

                      resolve({ status: true });
                      break;
                    }
                  }
                }
              }
            } else {
              resolve({ status: true });
            }
          })
          .catch((err) => {
            resolve({ status: false, message: "overlaps", error: err });
          });
      });
    },
    onSearchRateCard: function (screenIndex, movieIndex, RatecardIndex) {
      if (
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex]
          .scheduleShowPrice[RatecardIndex]["searchRateCard"].length > 0
      ) {
        this.RatecardsList = this.RatecardsListCopy.filter((x) => {
          if (
            x.rate_card_name
              .toLowerCase()
              .includes(
                this.selectedMoviesInScreens[screenIndex].movies[
                  movieIndex
                ].scheduleShowPrice[RatecardIndex][
                  "searchRateCard"
                ].toLowerCase()
              )
          )
            return x;
        });
      } else {
        this.RatecardsList = this.RatecardsListCopy;
      }
    },
    async getSchedule(flag) {
      let self = this;
      let payload = {};
      let loader = "";
      loader = this.$loading.show();
      this.selectedMoviesInScreens = this.selectedMoviesInScreens.map((x) => {
        x.movies = [];
        return x;
      });

      payload = {
        cinema_id: this.movieSelected.cinema_id
          ? this.movieSelected.cinema_id
          : this.cineid,
        start_date: moment(this.movieSelected.ss_start_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD"),
      };

      MyCinemaService.GetCinemaSchedule(payload)
        .then(async (result) => {
          const { data } = result;

          loader.hide();

          if (data.status) {
            if (data.Records.length > 0) {
              // if (this.movieSelected) {
              //   this.selectedMoviesInScreens.map(x => {
              //     // if (this.movieSelected.cinema_id == x.cinema_id) {
              //     //   this.selectedScreenSeatTypes = x.screen_seat_types;
              //     // }
              //   });
              // }
              let newRecords = data.Records;
              // let _newRecords = uniqBy(newRecords, "screen_id");

              const prom = await Promise.all(
                newRecords.map(async (y) => {
                  const prom1 = await Promise.all(
                    this.selectedMoviesInScreens.map((x) => {
                      if (String(y.screen_id) === String(x.screen_id)) {
                        let lengthMinutes =
                          y.mrrdr_runtime +
                          y.cine_cleaning_time_in_mins +
                          y.cine_setting_ads_time_in_mins +
                          y.cine_interval_time_in_mins;

                        let sign = this.movieSelected.tz_utc_offset.charAt(0);
                        let offset =
                          this.movieSelected.tz_utc_offset.substring(1);
                        let hours = offset.split(":")[0];
                        let minutes = offset.split(":")[1];

                        let timeZoneFlag =
                          momentT.tz.guess() === this.movieSelected.tz_name ||
                          ((momentT.tz.guess() == "Asia/Calcutta" ||
                            momentT.tz.guess() == "Asia/Kolkata") &&
                            (this.movieSelected.tz_name == "Asia/Kolkata" ||
                              this.movieSelected.tz_name == "Asia/Calcutta"));

                        x.movies.push({
                          lengthMinutes: lengthMinutes,
                          length: (lengthMinutes * 30) / 10,

                          start: getLength(y.ss_start_show_time, this),

                          selected_time: !timeZoneFlag
                            ? sign == "+"
                              ? moment(y.ss_start_date_time)
                                  .tz(this.movieSelected.tz_name)
                                  .add("-" + hours, "hours")
                                  .add("-" + minutes, "minutes")
                                  .format()
                              : moment(y.ss_start_date_time)
                                  .tz(this.movieSelected.tz_name)
                                  .add(hours, "hours")
                                  .add(minutes, "minutes")
                                  .format()
                            : moment(y.ss_start_date_time).format(),
                          movie_details_id: y.movie_details_id,
                          lang_name: y.language_name,
                          start_time: moment(y.ss_start_show_time, [
                            "HH:mm",
                          ]).format("h:mm A"),
                          end_time: moment(y.ss_end_show_time, [
                            "HH:mm",
                          ]).format("h:mm A"),
                          mf_name: y.movie_format,
                          movie_title: y.movie_title,
                          md_thumbnail_url: y.md_thumbnail_url,
                          ss_start_show_time: y.ss_start_show_time,
                          ss_end_show_time: y.ss_end_show_time,
                          scheduleShowPrice: y.scheduleShowPrice,
                          ss_start_date: y.ss_start_date,
                          ss_end_date: y.ss_end_date,
                          ss_start_date_time: y.ss_start_date_time,
                          ss_end_date_time: y.ss_end_date_time,
                          ss_is_active: y.ss_is_active,
                          ss_show_status: y.ss_show_status,
                          ss_actual_end_date_time: y.ss_actual_end_date_time,
                          ss_actual_start_date_time:
                            y.ss_actual_start_date_time,
                          // scd_reason: status_id == 17 ? y.scd_reason : "",
                          // scd_created_by: status_id == 17 ? y.username : ""
                        });
                      }
                      // console.log("x::::::::: :>> ", x);
                      return x;
                    })
                  );
                })
              );

              if (flag != "OnSelect") {
                this.$refs.ratecardmodal.show();
              }
            }
          }
          this.selectedScreenIndex = this.selectedMoviesInScreens.findIndex(
            (x) => {
              return x.screen_id == this.movieSelected.screen_id;
            }
          );

          this.ScreenList.map((x) => {
            // console.log("x :>> ", x);
            // console.log("this.movieSelected :>> ", this.movieSelected);
            if (x.screen_id == this.movieSelected.screen_id) {
              this.selectedScreenSeatTypes = x.screen_seat_types;
            }
          });

          // console.log(
          //   this.selectedScreenSeatType,
          //   this.selectedScreenSeatType.length,
          //   "fsdfsd"
          // );

          this.selectedMovieIndex = this.selectedMoviesInScreens[
            this.selectedScreenIndex
          ].movies.findIndex((x) => {
            return x.movie_details_id == this.movieSelected.md_id;
          });

          // this.selectedScreenSeatTypes.push(obj);
          this.selectedScreenSeatTypes =
            this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
              this.selectedMovieIndex
            ].scheduleShowPrice;
          // console.log(
          //   this.selectedScreenSeatTypes,
          //   "fdfdg",
          //   this.selectedMoviesInScreens
          // );
        })
        .catch((err) => {
          console.log("err :", err);
        });
      function getLength(startTime, ref) {
        let cinema_start = ref.getScreenPositionCalc(
          ref.CinemasSettings.cine_operation_start_time
        );
        let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              ref.CinemasSettings.cine_operation_end_time
          ).isSameOrBefore(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                ref.CinemasSettings.cine_operation_start_time
            )
          )
        ) {
          if (
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                ref.CinemasSettings.cine_operation_end_time
            ).isAfter(moment(moment().format("YYYY-MM-DD") + " " + startTime))
          ) {
            show_start_time = 4320 + ref.getScreenPositionCalc(startTime);
          } else {
            show_start_time = ref.getScreenPositionCalc(startTime);
          }
        } else {
          show_start_time = ref.getScreenPositionCalc(startTime);
        }

        let start_delay = ref.getScreenPositionCalc("00:30");
        return show_start_time - cinema_start + start_delay;
      }
    },
    getScreenPositionCalc: function (start_time) {
      let cinema_start_time = this.movieSelected.cine_operation_start_time;
      let cinema_ampm = cinema_start_time.split(" ")[0];
      let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
      let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

      let start = 0;
      let cinema_start = 0;
      let hours = 0;
      let minutes = 0;
      let totalMinutes = 0;
      let ampm = start_time.split(" ")[0];
      minutes = parseInt(start_time.split(":")[1]);
      hours = parseInt(start_time.split(":")[0]);
      if (ampm == "PM" && hours === 12) {
        hours = hours;
      } else if (ampm == "PM") {
        hours = hours + 12;
      }

      if (ampm == "AM" && hours === 12) {
        totalMinutes = minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      } else {
        totalMinutes = parseInt(hours * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 30) / 10;
        return cinema_start;
      }

      totalMinutes = parseInt(hours * 60) + minutes;
      cinema_start = parseInt(totalMinutes * 30) / 10;
      return cinema_start;
    },
    getStatuses() {
      ScheduleCommentService.GetStatuses()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.status_list = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    convertToTime: function (value, value1) {
      let totalMinutes = (this.movieSelected.start * 10) / 30;
      let _totalMinutes = Math.floor(
        totalMinutes + this.movieSelected.lengthMinutes
      );

      let _hours = Math.floor(_totalMinutes / 60);
      let _minutes = _totalMinutes % 60;
      let _ampm = "AM";
      if (_hours > 12) {
        _ampm = "PM";
        _hours = _hours - 12;
      }
      _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
      this.movieSelected.end_time = _hours + ":" + _minutes + " " + _ampm;

      let hours = Math.floor(totalMinutes / 60);
      let minutes = Math.floor(totalMinutes % 60);
      let ampm = "AM";
      if (hours > 12) {
        ampm = "PM";
        hours = hours - 12;
      }
      minutes = minutes >= 10 ? minutes : "0" + minutes;
      this.movieSelected.start_time = hours + ":" + minutes + " " + ampm;
      return hours + ":" + minutes + " " + ampm;
    },
    onChangeTimePicker: function (date) {
      var hours = moment(date).format("hh");
      var minutes = moment(date).format("mm");
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    getCommentsList() {
      ScheduleCommentService.GetComments()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.comments_list = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getScheduleComment(gogo_ss_id) {
      ScheduleCommentService.GetScheduleComment({ gogo_ss_id: gogo_ss_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              console.log("data.Records :", data.Records);

              this.selected_comment = {
                c_id: data.Records[0].c_id,
                comment_name: data.Records[0].comment_name,
              };
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onFinalSubmit() {
      ScheduleCommentService.AddScheduleComment({
        gogo_ss_id: this.update_gogo_ss_id,
        c_id: this.selected_comment.c_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            // this.$router.push({
            //   name: "Schedule Comments"
            // });
            this.$bvModal.hide("add_comment");
            this.Onfetch(true);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.Onfetch(true);
      } else {
        this.currentPage = event;
        this.Onfetch(false);
      }
    },
    changestatus: function () {
      this.openindi = true;
    },
    OpenModal: function (data, type) {
      if (type == "Comment") {
        this.update_gogo_ss_id = data;
        this.getScheduleComment(data);
        this.$bvModal.show("add_comment");
      } else if (type == "Schedule") {
        let self = this;
        let sign = data.tz_utc_offset.charAt(0);
        let offset = data.tz_utc_offset.substring(1);

        this.timeZone.tz_name = data.tz_name;
        this.timeZone.tz_utc_offset = data.tz_utc_offset;

        let timeZoneFlag =
          momentT.tz.guess() === data.tz_name ||
          ((momentT.tz.guess() == "Asia/Calcutta" ||
            momentT.tz.guess() == "Asia/Kolkata") &&
            (data.tz_name == "Asia/Kolkata" ||
              data.tz_name == "Asia/Calcutta"));

        this.movieSelected = data;

        this.CinemasSettings.cine_operation_start_time =
          data.cine_operation_start_time;

        this.CinemasSettings.cine_operation_end_time =
          data.cine_operation_end_time;

        this.movieSelected.length = (data.lengthMinutes * 30) / 10;
        this.movieSelected.selected_time = !timeZoneFlag
          ? sign == "+"
            ? moment(data.ss_start_date_time)
                .tz(data.tz_name)
                .add("-" + hours, "hours")
                .add("-" + minutes, "minutes")
                .format()
            : moment(data.ss_start_date_time)
                .tz(data.tz_name)
                .add(hours, "hours")
                .add(minutes, "minutes")
                .format()
          : moment(data.ss_start_date_time).format();

        this.$bvModal.show("updateMovie");
      } else if (type == "Price") {
        this.movieSelected = data;
        console.log("data :>> ", data);
        // this.selectedMovieIndex = screenMovieIndex;
        // this.selectedScreenIndex = screenIndex;
        // console.log("this.movieSelected :>> ", this.movieSelected);
        // console.log('this.selectedMoviesInScreens :>> ', this.selectedMoviesInScreens);

        this.CinemasSettings.cine_operation_start_time =
          data.cine_operation_start_time;

        this.CinemasSettings.cine_operation_end_time =
          data.cine_operation_end_time;

        this.RatecardsList.map((x) => {
          if (x.cinema_id == this.cineid) {
            return x;
          }
        });
        // console.log("this.RatecardsList :>> ", this.RatecardsList);

        this.getSchedule();
      }
    },
    hideModal: function (modal) {
      if (modal == "add_comment") {
        this.$bvModal.hide("add_comment");
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    clearSelectedDate: function () {
      this.showdate = "";
    },

    onSelectMovie: function (event) {
      this.selected.movie_name = event.movie_name;
      this.movieid = event.md_id;
      this.dateenable = false;
    },

    onSelectScreen: function (event) {
      // console.log("screen :", screen, screenindex);
      this.selected.screen_name = event.screen_name;
      this.screenid = event.screen_id;
    },
    onSelectStatus: function (event) {
      // console.log("screen :", screen, screenindex);
      this.selected.status_name = event.s_status_display;
      this.status_id = event.s_id;
    },

    onSelectCinema: function (event) {
      this.selected.cinema = event.cine_name;
      this.cineid = event.cine_id;
      this.Onfetch(true);
      this.getSchedule("OnSelect");
      this.getAllActiveScreens(event.cine_id);
    },

    getAllActiveCinemas: function (cine_id) {
      // let payload = null
      // cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            console.log("cinemalist", this.CinemasList);

            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.cinema = x.cine_name;
                this.cineid = x.cine_id;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.selectedCinema = cinema;
                // this.onSelectCinema(cinema);
              }
            });
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    GetAllActiveScreens: function () {
      this.ScreenList = [];
      this.selectedMoviesInScreens = [];

      scheduleService
        .GetAllActieScreens()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAllActiveScreens: function (cinema_id) {
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };

      this.selectedMoviesInScreens = [];

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
            console.log(this.selectedMoviesInScreens);
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAllActiveMovies: function () {
      scheduleService
        .GetMovies()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    /* eslint-disable */
    goToRoute: function (path, item) {
      const { screen_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: screen_id,
        },
      });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },

    Onfetch: function (check) {
      if (check) {
        this.currentPage = 1;
      }
      this.ScheduleList = [];
      let loader = this.$loading.show();

      let payload = {
        cinema_id: this.cineid,
        date: this.showdate,
        screen_id: this.screenid,
        movie_id: this.movieid,
        status_id: this.status_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        AscDescFlag: this.Flag,
        columnName: this.columnName, //For Ascending and Descending
      };
      this.btenable = true;

      MyCinemaService.getSchedulesV2(payload)
        .then((response) => {
          this.btenable = false;
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.ScheduleList = data.Records;
              console.log("this.ScheduleList", this.ScheduleList);
              this.RatecardsList = data.RateCardByCinema;
              this.RatecardsListCopy = data.RateCardByCinema;
              this.ScreenforCinema = data.ScreensByCinema;

              this.ScreenforCinema.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }

            // if (this.ScheduleList.length == 0) {
            //   this.$toasted.show(data.message);
            //   this.enable = true;
            // } else {
            //   this.enable = false;
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    OnClear: function () {
      this.selected_schedule = [];
      this.openindi = false;
      this.selected = {
        cinema: "",
        screen_name: "",
        movie_name: "",
        show_time: "",
        status_name: "",
      };

      this.showdate = "";
      this.cineid = "";
      this.screenid = "";
      this.movieid = "";
      this.status_id = null;

      this.Onfetch();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MyCinemaComponents/MultiScheduling/scheduleListV2.vue